module.exports = __webpack_public_path__ + "static/media/SFProText.d6079ef0.ttf";